import { createTheme } from "@mui/material";
import CircularStd from "../fonts/circular-std-medium-500.ttf";
export const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#0f53fa",
    },
    secondary: {
      main: "#ffffff",
    },
    background: {
      paper: "#f7f8fa",
      default: "#e5e5e5",
    },
  },
  typography: {
    fontFamily: '"Circular Std", sans-serif',
    h1: {
      fontWeight: 300,
      fontSize: "6rem",
    },
    h2: {
      fontSize: 300,
      fontSize: "3.75rem",
    },
    h3: {
      fontSize: "3rem",
      fontWeight: 400,
    },
    h4: {
      fontSize: "2.125rem",
      fontWeight: 400,
    },
    h5: {
      fontSize: "1.5rem",
      fontWeight: 400,
    },
    h6: {
      fontSize: "1.6rem",
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    button: {
      fontSize: "0.875rem",
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        text: {
          textTransform: "initial",
          color: "#ffffff",
        },
      },
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [CircularStd],
      },
    },
  },
});
